"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENTS_SCOPE = 'specs.groups';
exports.TABS_HOOK = 'tabsHook';
exports.GROUP_PAGE = 'group_page';
//https://pbo.wixpress.com/rpc-console-poc/wix-apps-webapp/app-jvm-137.42.wixprod.net/tpaDistributionService/getPublicApp?WyIzODM2YWUxOS04MDA0LTQyMmMtOTBhNC1hZWJlNzBhYWE0MjQiXQ==.e30=
exports.GROUP_WIDGET_ID = '513a5d84-3ebb-4ca6-a5aa-83effd2123b9';
//# sourceMappingURL=constants.js.map